// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F1wzuQ {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3) 0;
}

.MBb8iC {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-title-lg-font-size);
  font-weight: var(--type-title-lg-font-weight);
  line-height: var(--type-title-lg-line-height);
  color: var(--text-neutral-dark);
}

.quvUxM {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
}

.ECxdYt {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-2);
  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);
}

.mXurN3 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-neutral-dark);
}

.kWOGNn {
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-3) var(--spacing-2);
}

.w81Wj1 {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: var(--spacing-3);
  flex-wrap: wrap;
}

.myaJTG {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  margin-left: auto;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-160);
  color: var(--text-primary-medium);
}

.myaJTG:hover {
  text-decoration: underline;
}

.bZ7jdx {
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
  box-sizing: border-box;
  width: 304px;
  max-width: 100%;
  height: 36px;
  padding: 0 var(--spacing-1-5);
  background-color: var(--surface-neutral-white);
  border: 1px solid var(--stroke-neutral-silver);
  border-radius: var(--radius-s);
}

.DidzX6 {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: var(--spacing-3);
  flex-wrap: wrap;
}

.bZ7jdx:focus-within {
  border-color: var(--stroke-primary-medium);
}

.GaiMe9 {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.Leb3Az {
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
  outline: none;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.Leb3Az::placeholder {
  color: var(--text-neutral-stronger);
}

.ZsO48H {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: var(--spacing-0-5);
  border: none;
  background: none;
  border-radius: var(--radius-s);
  cursor: pointer;
}

.ZsO48H:focus-visible {
  outline: 2px solid var(--stroke-primary-medium);
  outline-offset: 1px;
}

.Ybntt1 {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.F3cCka {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-3);
  width: 100%;
  min-height: 373px;
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  text-align: center;
}

.akLNs7 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: var(--radius-pill);
  background-color: var(--inline-error-background);
}

.g8QGiX {
  width: 16px;
  height: 16px;
}

.GRYRwS {
  width: 32px;
  height: 32px;
}

.B0gGKI {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-1);
  width: 270px;
  max-width: 100%;
  color: var(--text-neutral-dark);
}

.tE0mi1 {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
}

.PDu45x {
  margin: 0;
  max-width: 178px;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-180);
}

.clLQLM {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.w01xNq {
  min-width: 100px;
}

@media (max-width: 768px) {
  .F1wzuQ {
    gap: var(--spacing-2);
    padding: var(--spacing-2) 0;
  }

  .ECxdYt {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-1-5);
  }

  .w81Wj1,
  .bZ7jdx {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorOrdersPage/EmissorOrdersPage.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8CAA8C;EAC9C,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;EAC9C,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3) 0;\n}\n\n.pageTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-lg-font-size);\n  font-weight: var(--type-title-lg-font-weight);\n  line-height: var(--type-title-lg-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.ordersCard {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n}\n\n.ordersHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-2);\n  padding: 0 var(--spacing-3) var(--spacing-2) var(--spacing-3);\n}\n\n.ordersTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-neutral-dark);\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  padding: 0 var(--spacing-3) var(--spacing-2);\n}\n\n.toolbarFilters {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: var(--spacing-3);\n  flex-wrap: wrap;\n}\n\n.exportReportLink {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  margin-left: auto;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-160);\n  color: var(--text-primary-medium);\n}\n\n.exportReportLink:hover {\n  text-decoration: underline;\n}\n\n.searchField {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  box-sizing: border-box;\n  width: 304px;\n  max-width: 100%;\n  height: 36px;\n  padding: 0 var(--spacing-1-5);\n  background-color: var(--surface-neutral-white);\n  border: 1px solid var(--stroke-neutral-silver);\n  border-radius: var(--radius-s);\n}\n\n.filterChips {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: var(--spacing-3);\n  flex-wrap: wrap;\n}\n\n.searchField:focus-within {\n  border-color: var(--stroke-primary-medium);\n}\n\n.searchIcon {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.searchInput {\n  flex: 1 1 auto;\n  min-width: 0;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.searchInput::placeholder {\n  color: var(--text-neutral-stronger);\n}\n\n.searchClear {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  padding: var(--spacing-0-5);\n  border: none;\n  background: none;\n  border-radius: var(--radius-s);\n  cursor: pointer;\n}\n\n.searchClear:focus-visible {\n  outline: 2px solid var(--stroke-primary-medium);\n  outline-offset: 1px;\n}\n\n.listArea {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-3);\n  width: 100%;\n  min-height: 373px;\n  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  text-align: center;\n}\n\n.emptyIconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 72px;\n  height: 72px;\n  border-radius: var(--radius-pill);\n  background-color: var(--inline-error-background);\n}\n\n.emptyIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.emptyRechargeIcon {\n  width: 32px;\n  height: 32px;\n}\n\n.emptyTextBlock {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-1);\n  width: 270px;\n  max-width: 100%;\n  color: var(--text-neutral-dark);\n}\n\n.emptyTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n}\n\n.emptyBody {\n  margin: 0;\n  max-width: 178px;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--line-height-180);\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.backButton {\n  min-width: 100px;\n}\n\n@media (max-width: 768px) {\n  .container {\n    gap: var(--spacing-2);\n    padding: var(--spacing-2) 0;\n  }\n\n  .ordersHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-1-5);\n  }\n\n  .toolbarFilters,\n  .searchField {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `F1wzuQ`,
	"pageTitle": `MBb8iC`,
	"ordersCard": `quvUxM`,
	"ordersHeader": `ECxdYt`,
	"ordersTitle": `mXurN3`,
	"toolbar": `kWOGNn`,
	"toolbarFilters": `w81Wj1`,
	"exportReportLink": `myaJTG`,
	"searchField": `bZ7jdx`,
	"filterChips": `DidzX6`,
	"searchIcon": `GaiMe9`,
	"searchInput": `Leb3Az`,
	"searchClear": `ZsO48H`,
	"listArea": `Ybntt1`,
	"emptyState": `F3cCka`,
	"emptyIconContainer": `akLNs7`,
	"emptyIcon": `g8QGiX`,
	"emptyRechargeIcon": `GRYRwS`,
	"emptyTextBlock": `B0gGKI`,
	"emptyTitle": `tE0mi1`,
	"emptyBody": `PDu45x`,
	"footer": `clLQLM`,
	"backButton": `w01xNq`
};
module.exports = ___CSS_LOADER_EXPORT___;
